import React, { useState } from "react";
import MapboxMap, { Marker } from 'react-map-gl';
import Box from "./Box";
import Pin from "./map/Pin";

interface Props {
  coordinates?:
  | ({ lat: number | null; lng: number | null } | null | undefined)[]
  | null;
}

const Map = ({ coordinates }: Props) => {
  const [{ latitude, longitude, zoom }, setLocation] = useState({
    latitude: coordinates?.[0]?.lat || 50.102247927045624,
    longitude: coordinates?.[0]?.lng || 14.430639997090125,
    zoom: 12
  })

  const filteredCoords = coordinates?.filter(c => !!c);

  if ((filteredCoords || []).length < 1) {
    return null;
  }

  return (
    <Box height={{ _: 300, md: 600 }} mb={{ _: 5, md: 6 }}>
      <MapboxMap
        width="100%"
        height="100%"
        onViewportChange={(position: any) => setLocation({ latitude: position.latitude, longitude: position.longitude, zoom: position.zoom })}
        mapStyle="mapbox://styles/mapbox/streets-v9"
        longitude={longitude}
        latitude={latitude}
        zoom={zoom}
        doubleClickZoom
        scrollZoom
        mapboxApiAccessToken={process.env.NEXT_PUBLIC_MAPBOX_MAP_API_KEY as string}
      >
        {filteredCoords?.map(coord => <Marker key={coord?.lng} latitude={coord?.lat as number} longitude={coord?.lng as number}>
          <Pin size={40} />
        </Marker>)}
      </MapboxMap>
    </Box>
  );
};

export default Map;
